<ng-container class="container" *ngIf="survey">

  <div class="glossary-area" *ngIf="isGlossaryAvailable()">
    <div class="glossary-image" (mouseenter)="showCompleteMessage()" (mouseleave)="hideMessage()" (click)="openGlossary()">
      <div class="speech-bubble" id="bubble">
        <span id="typingText" class="typing-text"></span>
        <span id="hoverMessage" class="hover-message">¿Necesitas aclarar algún término?</span>
      </div>
      <img src="assets/img/sv/glo_term.png" alt="Glosario de Términos">
      <div class="glossary-text">Glosario de términos</div>
    </div>

    <button class="glossary-button" (click)="openGlossaryModal()">
      <span class="glossary-label">Glosario</span>
    </button>

    <div class="modal-glosario" *ngIf="showModal">
      <div class="modal-content">
        <span class="close" (click)="closeGlossaryModal()">&times;</span>
        <div class="modal-body">
          <h2>Glosario de Términos</h2>
          <p>{{getGlossaryDetail()}}</p>
          <button class="btn btn-primary" (click)="openGlossary()">Ir al Glosario</button>
        </div>
      </div>
    </div>
  </div>




    <form autocomplete="off">
      <div class="row div-title">
        <div class="col-sm-3 text-center">
          <img class="img-fluid logo-survey" src="/assets/img/logo.png" alt="">
        </div>
        <div class="col-sm-9" style="position: relative;">
          <div class="input-title">
            {{survey.title}}
          </div>
        </div>
        <br>
      </div>
      <ng-container class="row">
        <ng-container class="col-12">
          <div id="error-message" class="alert alert-warning" style="display: none;">
            <strong>¡Atención!</strong> Por favor, completa todas las preguntas obligatorias marcadas en rojo.
          </div>
          <div id="error-message" class="alert alert-warning" style="display: none;">
            <strong>¡Atención!</strong> Por favor, responde todas las preguntas obligatorias antes de finalizar la encuesta.
          </div>
          <ng-container *ngIf="survey">
            <div >
              <div class="col-12 div-section" *ngFor="let s of survey.sections">
                <h3>{{s.title}}</h3>
                <p [innerHTML]="s.summary"></p>
                <p [innerHTML]="s.detail"></p>
                <ng-container *ngFor="let q of s.questions">
                  <div class="div-question" id="question-{{q.id}}">
                    <h5>{{q.label}}
                      <i class="fa fa-exclamation-circle warning-icon" *ngIf="q.isRequired && !hasAnswer(q.id)">
                        <span class="tooltip-text">Esta es una pregunta obligatoria</span>
                      </i>
                    </h5>
                    <p [innerHTML]="q.summary"></p>
                    <p [innerHTML]="q.detail"></p>
                    <ng-container *ngIf="q.idquestiontype === 1"><!--politomica-->
                      <div class="row div-options">
                        <ng-container *ngFor="let o of q.options">
                          <div class="col-sm-3 form-group">
                            <div class="form-check">
                              <input class="form-check-input radio" type="radio"
                                name="flexRadioDefault-{{q.id}}" id="{{o.id}}">
                              <label class="form-check-label radio-label" for="{{o.id}}">
                                {{o.label}}
                              </label>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="q.idquestiontype === 9"><!--texto simple-->
                      <div class="row div-options">
                        <ng-container *ngFor="let o of q.options">
                          <div class="col-sm-6 form-group">
                            <ng-container *ngIf="o.label.length > 0">
                              <label class="form-label" for="{{o.id}}">
                                {{o.label}}
                              </label>
                            </ng-container>
                            <input class="form-control" type="text" name="flexRadioDefault-{{q.id}}"
                              id="{{o.id}}">
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="q.idquestiontype === 7"> <!-- input numero -->
                      <div class="row div-options">
                        <ng-container *ngFor="let o of q.options">
                          <div class="col-sm-6 form-group">
                            <ng-container *ngIf="o.label.length > 0">
                              <label class="form-label" for="{{o.id}}">
                                {{o.label}}
                              </label>
                            </ng-container>
                            <input class="form-control" type="number" name="flexRadioDefault-{{q.id}}"
                                  id="{{o.id}}">
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="q.idquestiontype === 13"><!-- carreras -->
                      <div class="row div-options">
                        <ng-container *ngFor="let o of q.options">
                          <div class="col-sm-6 form-group">
                            <ng-container *ngIf="o.label.length > 0">
                              <label class="form-label" for="{{o.id}}">
                                {{o.label}}
                              </label>
                            </ng-container>
                            <input class="form-control" type="text" name="flexRadioDefault-{{q.id}}"
                                  id="{{o.id}}"
                                  (input)="filterCareers($event.target.value, q.id, o.id)"
                                  (focus)="onFocusCareers()"
                                  (blur)="onBlurCareers()"
                                  [placeholder]="'Escribe para buscar o ingresar una nueva carrera...'">
                            <div *ngIf="isCareersDropdownVisible" class="dropdown-menu show">
                              <button *ngFor="let career of filteredCareers" class="dropdown-item"
                                      (click)="selectCareer(career, q.id, o.id)">
                                {{career.name}}
                              </button>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="q.idquestiontype === 14"><!--paises-->
                      <div class="row div-options">
                        <ng-container *ngFor="let o of q.options">
                          <div class="col-sm-6 form-group">
                            <ng-container *ngIf="o.label.length > 0">
                              <label class="form-label" for="{{o.id}}">
                                {{o.label}}
                              </label>
                            </ng-container>
                            <input class="form-control" type="text" name="flexRadioDefault-{{q.id}}"
                                  id="{{o.id}}"
                                  (input)="filterCountries($event.target.value, q.id, o.id)"
                                  (focus)="onFocusCountries()"
                                  (blur)="onBlurCountries()"
                                  [placeholder]="'Escribe para buscar...'">
                            <div *ngIf="isCountriesDropdownVisible" class="dropdown-menu show">
                              <button *ngFor="let country of filteredCountries" class="dropdown-item"
                                      (click)="selectCountry(country, q.id, o.id)">
                                {{country.name}}
                              </button>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="q.idquestiontype === 15"><!--departamentos-->
                      <div class="row div-options">
                        <ng-container *ngFor="let o of q.options">
                          <div class="col-sm-6 form-group">
                            <ng-container *ngIf="o.label.length > 0">
                              <label class="form-label" for="{{o.id}}">
                                {{o.label}}
                              </label>
                            </ng-container>
                            <input class="form-control" type="text" name="flexRadioDefault-{{q.id}}"
                                  id="{{o.id}}"
                                  (input)="filterStates($event.target.value, q.id, o.id)"
                                  (focus)="onFocusStates()"
                                  (blur)="onBlurStates()"
                                  [placeholder]="'Escribe para buscar...'"
                                  [disabled]="!selectedCountryId"> <!-- Deshabilitar si no se ha seleccionado un país -->
                            <div *ngIf="isStatesDropdownVisible && filteredStates.length > 0" class="dropdown-menu show">
                              <button *ngFor="let state of filteredStates" class="dropdown-item">
                                {{state.name}}
                              </button>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="q.idquestiontype === 11">
                      <div class="row div-options">
                        <ng-container *ngFor="let o of q.options">
                          <div class="col-sm-12 form-group">
                            <label class="form-label" for="{{o.id}}">
                              {{o.label}}
                            </label>
                            <table class="table">
                              <thead>
                                <tr>
                                  <th scope="col"></th>
                                  <ng-container *ngFor="let a of o.axis">
                                    <ng-container *ngIf="a.type === 2">
                                      <th class="text-center" scope="col">{{a.label}}</th>
                                    </ng-container>
                                  </ng-container>
                                </tr>
                              </thead>
                              <tbody>
                                <ng-container *ngFor="let a of o.axis">
                                  <ng-container *ngIf="a.type === 1">
                                    <tr id="row-{{q.id}}-{{a.id}}">
                                      <th scope="row"><p [innerHTML]="a.label"></p></th>
                                      <ng-container *ngFor="let b of o.axis">
                                        <ng-container *ngIf="b.type === 2">
                                          <td class="text-center">
                                            <input class="radio" type="radio"
                                              [name]="'radio-' + q.id + '-' + a.id"
                                              [id]="o.id + '-' + b.id">
                                          </td>
                                        </ng-container>
                                      </ng-container>
                                    </tr>
                                  </ng-container>
                                </ng-container>

                              </tbody>
                            </table>
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="q.idquestiontype === 3">
                      <div class="row div-options">
                        <ng-container *ngFor="let o of q.options">
                          <div class="col-sm-3 form-group">
                            <div class="form-check">
                              <input class="form-check-input checkbox" type="checkbox"
                                name="flexCheckboxDefault-{{q.id}}" id="{{o.id}}">
                              <label class="form-check-label checkbox-label" for="{{o.id}}">
                                {{o.label}}
                              </label>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="q.idquestiontype === 16">
                      <div class="row">
                        <div class="col-12" *ngFor="let o of q.options">
                          <h2 class="title-text" [innerHTML]="o.label"></h2>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </ng-container>
            </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </form>

</ng-container>
